import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import formData from "./formData"; // 确保这是正确的导入路径和大小写

const reactapiApi = createApi({
    reducerPath: 'reactapiApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '/x/rap'        
    }),
    tagTypes: ['account', 'uploadPic'], // 添加了 uploadPic
    endpoints: (build) => ({ // 使用箭头函数返回对象       
        // 账号列表
        zd_system_account_list: build.query({
            query: (user) => ({ // 使用明确的键值对                
                url: '/zd_system_account_list',
                method: 'post',
                body: formData(user) // 注意大小写
            }),                     
            providesTags: ['account'],
        }),         
        // 获取手机图片上传token
        app_upload_image_token: build.mutation({
            query: (user) => ({                
                url: '/app_upload_image_token',
                method: 'post',
                body: formData(user)
            }),                     
        }),         
        // 手机图片上传
        app_multiple_upload_image: build.mutation({
            query: (user) => ({                
                url: '/app_multiple_upload_image',
                method: 'post',
                body: formData(user)
            }),                     
            invalidatesTags: ['uploadPic']
        }),         
        // 获取手机上传图片列表
        app_image_list: build.query({
            query: (user) => ({                
                url: '/app_image_list',
                method: 'post',
                body: formData(user)
            }),                     
            providesTags: ['uploadPic']
        }),         
    })
});

export const {   
    useZd_system_account_listQuery,
    useApp_upload_image_tokenMutation, 
    useApp_multiple_upload_imageMutation,
    useApp_image_listQuery,
} = reactapiApi;

export default reactapiApi;